export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista tipos de inspecciones"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir"])},
          "general_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte general"])},
          "quality_inspects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de calidad"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to inspection types"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])},
          "general_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download general report"])},
          "quality_inspects_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspections"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspections"])}
        }
      }
    }
  })
}